import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StorageService } from 'digital-core';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { GTMOnboardingEvents, OnboardingSteps } from 'src/app/model/google-tag-manager/api-status';

@Component({
  selector: 'app-email-confirmation-flow',
  templateUrl: './email-confirmation-flow.component.html',
  styleUrls: ['./email-confirmation-flow.component.scss']
})
export class EmailConfirmationFlowComponent implements OnInit {

  @Input() public emailAddress = '';
  @Output() public emailConfirmed: EventEmitter<any> = new EventEmitter();

  constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
    private storageService: StorageService
  ) { }

  ngOnInit(): void { }

  onNextEmailFlow() {
    this.googleAnalyticsService.emitOnboardingEvent(GTMOnboardingEvents.Start, OnboardingSteps.Start);
    this.storageService.setSession('RegEmail', this.emailAddress);
    this.emailConfirmed.emit();
  }
}
